module.exports = __webpack_public_path__ + "img/xestia-c-nigrum.434276f5.jpg";